/**
 * @title rxFamilyAccount.js: Sub-module for Global pages
 * @description This module is used for manage family account
 * @dependency 
 */
define(['membershipHelper'], function(helper) {	


	let rxFamilyAccount = {
			
	/**
	 * The method displays the modal window to users to provide dependent details. 
	 * Collected details are then passed onto Patient-profile page when the form was submitted based once the values are validated.
	 */
	addNewDependent: function() {
		COSTCO.dialog.createExtDialogBox({
	    		title : messages.FAMILYACCOUNT_PHARMACY_ADD_BUTTON_LABEL,
	    		body : COSTCO.util.tmpl('dependent_details_modal', {}),
    			primary : messages.FAMILYACCOUNT_PHARMACY_NEXT_BUTTON_LABEL,
	    		secondary : messages.BUTTON_CANCEL,
				primary_event: function(){
					if(rxFamilyAccount.addDependentFormHandler()){
						 let month = $('#month').val();
					     let day = $('#day').val();
					     let year = $('#year').val();
					     let errorField = '#crit-error';
					     let alertField = '#alert-relationship-error';
					   	 let selectedDependentId = $("#relationship option:selected").val();
					   	 let selectedDependentDesc = $("#relationship option:selected").attr("id");
					     let isDepAllowed = true;
					     let options = {year: 'numeric', month: 'long', day: 'numeric'};
					     var depDob = new Date(year, month-1, day).toLocaleDateString("en-US", options);
					     let profileType;
					     let featureToggleOff = $('#featureToggleOff').val();
					     let isAgeAllowed = function() {
					    	 let currentDate = new Date();
					    	 let idate = new Date(year, month-1, day);						  
					    	 let age = currentDate.getTime() - idate.getTime();
					    	 age = Math.floor(age / (1000 * 60 * 60 * 24 * 365.25));
					    	 return age < 17 ? true : false; 
					    };
						  $('#newDepRelationshipDesc').val(selectedDependentDesc);
						  $('#newDepRelationshipId').val(selectedDependentId);
						  if(selectedDependentDesc != undefined && selectedDependentDesc != "Pet"){
							  if (featureToggleOff === 'featureDisabled' && !isAgeAllowed()) {
						    	   isDepAllowed = false;
						    	   $(errorField)[0].innerHTML = messages.ERR_DEPENDENT_AGE;
						    	   $(errorField).show();
						    	   $(errorField).focus();
						    	   COSTCO.util.announceSRErrorMessage(messages.ERR_DEPENDENT_AGE);
							   }						  							  
							  profileType = "0";					 
						} else {
							profileType = "1";
						}
						$('#newDepProfileType').val(profileType);
						$('#dependentDob').val(depDob); 
						if(isDepAllowed) {
							$(errorField).hide();
							window.digitalDataEvents = window.digitalDataEvents || [];
							digitalDataEvents.push( { uimsg:"Manage Family Account | Add Family Member Modal | Next" } );
							$( "#dependent-modal" ).submit();
						}
					} else {
						var firstError = $(".error:visible:first");
						firstError.focus();
						if ( firstError.parents(".dobPopulate").length){
							COSTCO.util.announceSRErrorMessage($("#dob_error")[0].innerText);
						} else if(firstError.is(":radio")){
							COSTCO.util.announceSRErrorMessage($(".error:visible:last")[0].innerText);
						} else {
							COSTCO.util.announceSRErrorMessage($(".error:visible:first").next()[0].innerText);
						}
					}				
				},
				secondary_event: () => {
				    window.digitalDataEvents = window.digitalDataEvents || [];
					digitalDataEvents.push( { uimsg:"Manage Family Account | Add Family Member Modal | Cancel" } );
					COSTCO.dialog.close();
		        },
				onshown : function() {
					helper.dobPopulate(rxFamilyAccount.getForm(), 100);	
					$('.control--radio input[type="radio"]').on("focusin", function(){
						$(this).next().addClass('ada-outline');
					})

					$('.control--radio input[type="radio"]').on("blur", function(){
						$(this).next().removeClass('ada-outline');
					})
				}
	    	});
	 },
	validateEmail: function(value) {	
			var flag = true;		
			flag = flag && /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value.toLowerCase());
			return flag;
	},

	checkFirstNameValid: function() {
		let firstName = COSTCO.rxFamilyAccount.getForm().find('input[name=firstName]');
		let firstNameValue = firstName.val();
		if (firstNameValue == "") {
			firstName.attr('aria-invalid', true);
			firstName.addClass('error');
			$('#firstName_error')[0].innerHTML = messages.ERR_INVALID_FIRSTNAME;
			$('#firstName_error').show();
			return false;
		}
		let isValid = COSTCO.util.ATLEAST_ONE_ALPHABET.test(firstNameValue);
		if (!isValid) {
			firstName.attr('aria-invalid', true);
			firstName.addClass('error');
			$('#firstName_error')[0].innerHTML = messages.ERR_INVALID_FIRSTNAME;
			$('#firstName_error').show();
			return false;
		}
		firstName.attr('aria-invalid', false);
		firstName.removeClass('error');
		$('#firstName_error').hide();
		return isValid;
	},

	checkLastNameValid: function() {
		let lastName = COSTCO.rxFamilyAccount.getForm().find('input[name=lastName]');
		let lastNameValue = lastName.val();
		if (lastNameValue == "") {
			lastName.attr('aria-invalid', true);
			lastName.addClass('error');
			$('#lastName_error')[0].innerHTML = messages.ERR_INVALID_LASTNAME;
			$('#lastName_error').show();
			return false;
		}
		let isValid = COSTCO.util.ATLEAST_ONE_ALPHABET.test(lastNameValue);
		if (!isValid) {
			lastName.attr('aria-invalid', true);
			lastName.addClass('error');
			$('#lastName_error')[0].innerHTML = messages.ERR_INVALID_LASTNAME;
			$('#lastName_error').show();
			return false;
		}
		lastName.attr('aria-invalid', false);
		lastName.removeClass('error');
		$('#lastName_error').hide();
		return isValid;
	},

	checkDOBValid: function() { 
		let form = COSTCO.rxFamilyAccount.getForm();		
	    let month = form.find('select[name=month]').val();
	    let day =  form.find('select[name=day]').val();
	    let year = form.find('select[name=year]').val(); 
		let errField = $('#dob_error');
	    let isFuture = false;
	    let dateEntered = false;
		let idate;
	     
	    let isFutureDate = function(idate) {
	    	let today = new Date().getTime();
	    	idate = idate.split('/');
	    	idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
	    	return (today - idate) < 0 ? true : false;
		};

		dateEntered = month != 'Month' & day != 'Day' & year != 'Year';
		
		if (month != 'Month' && day != 'Day' && year != 'Year') {
	       	idate = month + '/' + day + '/' + year;
	       	if (isFutureDate(idate)) {
				isFuture = true;
	      	}
	    }

	    if (dateEntered && !isFuture) {
			$('.dateOfBirth').removeClass('error select-error');
			$(errField).hide();
			return true;
		} else {
			$('.dateOfBirth').addClass('error select-error');
			$(errField).show();
			if (isFuture) {
	         	$(errField)[0].innerHTML = messages.ERR_INCORRECT_DATE_OF_BIRTH;
	       	}else {
				$(errField)[0].innerHTML = messages.ERR_REQUIRED_DOB;
	       	}
		}
		return false;
	},

	checkDOBMonthValid: function() {
		let isDOBValid = COSTCO.rxFamilyAccount.checkDOBValid();
		let month = $('#month').val();
		if (month == "Month") {
			$('#month').attr('aria-invalid', true);
			$('#month').addClass('error select-error');
			$('#dob_error')[0].innerHTML = messages.ERR_INVALID_MONTH;
			return false;
		}
		if (!isDOBValid) {
			$('#month').attr('aria-invalid', true);
			$('#month').addClass('error select-error');
			return false;
		}
		$('#month').attr('aria-invalid', false);
		$('#month').removeClass('error select-error');
		return true;
	},

	checkDOBDayValid: function() {
		let isDOBValid = COSTCO.rxFamilyAccount.checkDOBValid();
		let day = $('#day').val();
		if (day == "Day") {
			$('#day').attr('aria-invalid', true);
			$('#day').addClass('error select-error');
			$('#dob_error')[0].innerHTML = messages.ERR_INVALID_DAY;
			return false;
		}
		if (!isDOBValid) {
			$('#day').attr('aria-invalid', true);
			$('#day').addClass('error select-error');
			return false;
		}
		$('#day').attr('aria-invalid', false);
		$('#day').removeClass('error select-error');
		return true;
	},

	checkDOBYearValid: function() {
		let isDOBValid = COSTCO.rxFamilyAccount.checkDOBValid();
		let year = $('#year').val();
		if (year == "Year") {
			$('#year').attr('aria-invalid', true);
			$('#year').addClass('error select-error');
			$('#dob_error')[0].innerHTML = messages.ERR_INVALID_YEAR;
			return false;
		}
		if (!isDOBValid) {
			$('#year').attr('aria-invalid', true);
			$('#year').addClass('error select-error');
			return false;
		}
		$('#year').attr('aria-invalid', false);
		$('#year').removeClass('error select-error');
		return true;
	},

	checkPatientRelationshipValid: function() {
		let selectedDependent = $('#relationship').val();
		if (selectedDependent == 0) {
			$('#relationship').attr('aria-invalid', true);
			$('#relationship').addClass('error');
			$('#relationship_error')[0].innerHTML = messages.ERR_INVALID_RELATIONSHIP;
			$('#relationship_error').show();
			return false;
		}
		$('#relationship').attr('aria-invalid', false);
		$('#relationship').removeClass('error');
		$('#relationship_error').hide();
		return true;
	},

	checkGenderValid: function() {
		let genderCheck = $('[name^=depGender]:checked');
		if (genderCheck.length < 1) {
			$('#depGender_error')[0].innerHTML = messages.ERR_REQUIRED_GENDER;
			$('#depGender_error').show();
			return false;
		}
		$('#depGender_error').hide();
		return true;
	},

	 /**
	 * Add validation method to check human patient age
	 */	 
	 isHumanDependentsAgeAllowed: function() {
		 var selectedDependent = $("#relationship option:selected").val();
		 let month = $('#month').val();
	     let day = $('#day').val();
	     let year = $('#year').val();
	     let currentDate = new Date();
		 let idate = new Date(year, month-1, day);							  
		   let age = currentDate.getTime() - idate.getTime();
	       age = Math.floor(age / (1000 * 60 * 60 * 24 * 365.25));
	       let ageOnBirthday = currentDate.getTime() - idate.getTime();
	       ageOnBirthday = Math.round(ageOnBirthday / (1000 * 60 * 60 * 24 * 365.25));

	       if(ageOnBirthday > 17 && idate.getDate() == currentDate.getDate() && idate.getMonth() == currentDate.getMonth()) {
		       	$('#family-member-email-address').removeClass('hidden');
		        return true;
		   }	         	         
	       else if(age <= 17 || selectedDependent === "6" ) {
	        	$('#family-member-email-address').addClass('hidden');
	        	$('#emailAddress').val('');
	        	return false;
		 } else {
			 	$('#family-member-email-address').removeClass('hidden');
			 	return true;
		 }	
	 },
	 /**
		 * Add validation method to check selected patient relationship
		 */	 
	 checkSelectedPatientRelationship: function() {
		var selectedDependent = $("#relationship option:selected").val();
	    if(selectedDependent === "6" || rxFamilyAccount.isHumanDependentsAgeAllowed() == false) {
	    	$('#family-member-email-address').addClass('hidden');
		 	$('#emailAddress').val('');
	  		 return false    	   
	     } else {
	    	 $('#family-member-email-address').removeClass('hidden');
	    	return true;
	     }
		
	 },
		/**
		 * Opens learn more dialog on click "Learn more" link from Manage Family Account
		 */
	 showLearnMoreModal: function() {	
		  COSTCO.dialog.modalStack({
				title: messages.LEARN_MORE_ACCOUNT_STATUS_TITLE,
	    		body : COSTCO.util.tmpl('learn_more_modal', {}),
				primary : messages.JS_DIALOG_CLOSE,
				primary_event:  () => {
					 COSTCO.dialog.close();
				}
			});
	 },
	 
		/**
		 * Opens info dialog on click "Remove" link from Manage Family Account
		 */
		showRemoveInfoModal: function(primaryShopperId, dependentShopperId, firstName, lastName, index) {		
		  COSTCO.dialog.modalStack({
				title: messages.REMOVE_DEPENDENT_TITLE,
	    		body : COSTCO.util.tmpl('remove_modal', {
	    			 firstName: firstName,
	    		        lastName: lastName,
	    		}),
				primary : messages.REMOVE_DEPENDENT_BUTTON,
	    		secondary : messages.JS_DIALOG_CANCEL,
				primary_event:  () => {
					 COSTCO.dialog.close();
					  $('#primaryShopperId').val(primaryShopperId);
					  $('#dependentShopperId').val(dependentShopperId);
					  if(sessionStorage.getItem("SelectedPatientIndex")==index){
				    	  sessionStorage.removeItem("SelectedPatientIndex");
					  }
					$("#remove_dependent_modal").submit();
				}
			});
		  
		},
		
		emailDependentValidation: function() {
			
			// custom validation for email address
			//$.validator.addMethod('emailAddress', function(value, element, param) {		
			       
			    let emailFormat = $('#emailAddress').val();
			    let accountEmailRegister = $('#accountEmailRegister').val();
				 if(emailFormat === "" || rxFamilyAccount.validateEmail(emailFormat) == false) {
					let errField = '#family_member_email_address_error';
					let errorFieldEmailValidate = '#family_member_email_address_error';
					$('#emailAddress').addClass('error select-error');
				    $('#family_member_email_address_error').removeClass('hidden');

					$(errorFieldEmailValidate)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS_SEND_REQUEST;
					$(errorFieldEmailValidate).show();
					$(errorFieldEmailValidate).focus();
					$(errField)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS_SEND_REQUEST;

				    COSTCO.util.announceSRErrorMessage($("#family_member_email_address_error")[0].innerText);	
				    $('#family_member_email_address_error').addClass('visible');
				    $('#family_member_account_manager_email_address_error').addClass('hidden');
				    valid=false;
				}
				else if(accountEmailRegister.toLowerCase() === emailFormat.toLowerCase()) {
			    	let errField = '#family_member_account_manager_email_address_error';
					let errorFieldEmailValidate = '#family_member_account_manager_email_address_error';
					$('#emailAddress').addClass('error select-error');
				    $('#family_member_account_manager_email_address_error').removeClass('hidden');

					$(errorFieldEmailValidate)[0].innerHTML = messages.ERR_ACCOUNT_MANAGER_FAMILY_MEMBER_EMAIL_ADDRESS;
					$(errorFieldEmailValidate).show();
					$(errorFieldEmailValidate).focus();
					$(errField)[0].innerHTML = messages.ERR_ACCOUNT_MANAGER_FAMILY_MEMBER_EMAIL_ADDRESS;

				    COSTCO.util.announceSRErrorMessage($("#family_member_account_manager_email_address_error")[0].innerText);	
				    $('#family_member_account_manager_email_address_error').addClass('visible');
				    $('#family_member_email_address_error').addClass('hidden');
				    valid=false;
				}
				else {					 
					 $('#family_member_email_address_error').addClass('hidden');
					 $('#family_member_account_manager_email_address_error').addClass('hidden');
					 valid=true
					 
				 }
				  return valid;
			  
		},
		/**
		 * Open info Resend Email Request modal on click from Manage Family Account
		 */
		showResendEmailRequestModal: function(dependentEmailAddress, dependentShopperId) {		
			COSTCO.dialog.createExtDialogBox({
					title: messages.RESEND_EMAIL_REQUEST_DEPENDENT,
		    		body : COSTCO.util.tmpl('resend_email', {
		    			dependentEmailAddress: dependentEmailAddress,
		    			dependentShopperId: dependentShopperId		    			
		    		}),
					primary : messages.SEND_REQUEST_DEPENDENT_BUTTON,
					secondary : messages.JS_DIALOG_CANCEL,
					preventClose: true,
					primary_event:  () => {
						$('#dependentShopperId').val(dependentShopperId);
						$('#dependentEmailAddress').val(dependentEmailAddress);

						if(rxFamilyAccount.emailDependentValidation()){
						    window.digitalDataEvents = window.digitalDataEvents || [];
							digitalDataEvents.push( { uimsg:"Manage Family Account | Email Modal | Send Request" } );
							$("#resend_email_request").submit();
						} 
						
					},
					secondary_event: () => {
					    window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push( { uimsg:"Manage Family Account | Email Modal | Cancel" } );
						COSTCO.dialog.close();
			        }
				}); 
		},
		
		/**
		 * Open info Send Email Request modal on click from Manage Family Account
		 */
		showSendEmailRequestModal: function(dependentEmailAddress, dependentShopperId) {		
			  COSTCO.dialog.modalStack({
					title: messages.SEND_EMAIL_REQUEST_DEPENDENT,
		    		body : COSTCO.util.tmpl('send_email', {
		    			dependentEmailAddress: dependentEmailAddress,
		    			dependentShopperId: dependentShopperId	
		    		}),
		    		primary : messages.SEND_REQUEST_DEPENDENT_BUTTON,
					secondary : messages.JS_DIALOG_CANCEL,
					preventClose: true,
					primary_event:  () => {
						$('#dependentShopperId').val(dependentShopperId);
						$('#dependentEmailAddress').val(dependentEmailAddress);

						if(rxFamilyAccount.emailDependentValidation()){
							window.digitalDataEvents = window.digitalDataEvents || [];
							digitalDataEvents.push( { uimsg:"Manage Family Account | Email Modal | Send Request" } );
							$("#send_email_request").submit();
						} 
					},
					secondary_event: () => {
					    window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push( { uimsg:"Manage Family Account | Email Modal | Cancel" } );
						COSTCO.dialog.close();
			        }
				}); 
		},
		
	/**
	 * Add validation methods for form validation
	 */
	addValidationMethods: function() {

		$.validator.setDefaults({
			onfocusout: false
		});

		COSTCO.rxFamilyAccount.getForm().find("input[name=firstName]").on("focus", function() {
			$(".ally-error-msg").removeAttr("role");
			$("#firstName_error").attr("role", "alert");
			COSTCO.rxFamilyAccount.checkFirstNameValid();
		});

		COSTCO.rxFamilyAccount.getForm().find("input[name=lastName]").on("focus", function() {
			$(".ally-error-msg").removeAttr("role");
			$("#lastName_error").attr("role", "alert");
			COSTCO.rxFamilyAccount.checkLastNameValid();
		});

		$("#relationship").on("focus", function() {
			$(".ally-error-msg").removeAttr("role");
			$("#relationship_error").attr("role", "alert");
			COSTCO.rxFamilyAccount.checkPatientRelationshipValid();
		});

		$("#month").on("focus", function() {
			$(".ally-error-msg").removeAttr("role");
			$("#dob_error").attr("role", "alert");
			COSTCO.rxFamilyAccount.checkDOBMonthValid();
		});

		$("#day").on("focus", function() {
			$(".ally-error-msg").removeAttr("role");
			$("#dob_error").attr("role", "alert");
			COSTCO.rxFamilyAccount.checkDOBDayValid();
		});

		$("#year").on("focus", function() {
			$(".ally-error-msg").removeAttr("role");
			$("#dob_error").attr("role", "alert");
			COSTCO.rxFamilyAccount.checkDOBYearValid();
		});

		$("#dependent_acc_male").on("focus", function() {
			$("#depGender_error").attr("role", "alert");
			COSTCO.rxFamilyAccount.checkGenderValid();
		});

		$("#relationship").on("change", function() {
			COSTCO.rxFamilyAccount.checkPatientRelationshipValid();
		});
		
		$("#month").on("change", function() {
			COSTCO.rxFamilyAccount.checkDOBMonthValid();
		});

		$("#day").on("change", function() {
			COSTCO.rxFamilyAccount.checkDOBDayValid();
		});

		$("#year").on("change", function() {
			COSTCO.rxFamilyAccount.checkDOBYearValid();
		});
		
		// custom validation for email address
		$.validator.addMethod('emailAddress', function(value, element, param) {		   	
		   	let form = COSTCO.rxFamilyAccount.getForm();	      	
		    let valid = true;		     
		    let emailFormat = $('#emailAddress').val();
		    let accountEmailRegister = $('#accountEmailRegister').val();
			if(rxFamilyAccount.isHumanDependentsAgeAllowed() && rxFamilyAccount.checkSelectedPatientRelationship() == true && (emailFormat === "" || rxFamilyAccount.validateEmail(emailFormat) == false || accountEmailRegister.toLowerCase() === emailFormat.toLowerCase())) {
				let errField = '#family_member_email_address_error';
				let errEmptyField = '#family_member_email_empty_error';
				$('#emailAddress').addClass('error select-error');
			    if(accountEmailRegister.toLowerCase() === emailFormat.toLowerCase()){
					let errorFieldEmailValidate = '#family_member_email_address_error';
				    $('#family_member_email_empty_error').addClass('hidden');
				    $('#family_member_email_address_error').removeClass('hidden');
					$("#family_member_email_address_error").attr("role", "alert");
			    	$(errorFieldEmailValidate)[0].innerHTML = messages.ERR_ACCOUNT_MANAGER_FAMILY_MEMBER_EMAIL_ADDRESS;
			    	$(errorFieldEmailValidate).show();
			    	$(errorFieldEmailValidate).focus();
			    	$(errField)[0].innerHTML = messages.ERR_ACCOUNT_MANAGER_FAMILY_MEMBER_EMAIL_ADDRESS;
			    } 
			    else if(emailFormat === "") {
					let errorFieldEmailValidate = '#family_member_email_empty_error';
				    $('#family_member_email_address_error').addClass('hidden');
				    $('#family_member_email_empty_error').removeClass('hidden');
			    	$(errorFieldEmailValidate)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS;
					$(errorFieldEmailValidate).show();
					$(errorFieldEmailValidate).focus();
					$(errEmptyField)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS;	    	
			    }
			    else {
					let errorFieldEmailValidate = '#family_member_email_address_error';
				    $('#family_member_email_empty_error').addClass('hidden');
				    $('#family_member_email_address_error').removeClass('hidden');
					$("#family_member_email_address_error").attr("role", "alert");
			    	$(errorFieldEmailValidate)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS_SEND_REQUEST;
			    	$(errorFieldEmailValidate).show();
			    	$(errorFieldEmailValidate).focus();
			    	$(errField)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS_SEND_REQUEST;
			    }
			    valid=false;
			 } else {
				 
				 $('#family_member_email_address_error').addClass('hidden');
				 valid=true
				 
			 }
		     return valid;
		   }, '');		
		
	// custom validation for date of birth
		$.validator.addMethod('dob', function(value, element, param) {
   	
	   	let form = COSTCO.rxFamilyAccount.getForm();	      	
	     let valid = true;
	     let month;
	     let day;
	     let year;
	     let errField;
	     let idate;
	     let isFuture = false;
	    
	     let dateEntered = false;
	     
	     let isFutureDate = function(idate) {
	       let today = new Date().getTime();
	       idate = idate.split('/');
	       idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
	       return (today - idate) < 0 ? true : false;
	     };

	     
	     if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
	       month = form.find('select[name=month]').val();
	       day = form.find('select[name=day]').val();
	       year = form.find('select[name=year]').val();
	       dateEntered = (month != 'Month' & day != 'Day' & year != 'Year');
	       errField = '#dob_error';
	     }      
	     if (month != 'Month' && day != 'Day' && year != 'Year') {
	       idate = month + '/' + day + '/' + year;
	       if (isFutureDate(idate)) {
	       	isFuture = true;
	       }
        
	     }
	     if (dateEntered && !isFuture) {
	       $(errField).hide();
	       $('.dateOfBirth').removeClass('error select-error');
	       valid = true;
	     } else {
	       $(element).closest('.dateOfBirth').addClass('error select-error');
	       $(errField).show();
	       if (isFuture) {
	         $(errField)[0].innerHTML = messages.ERR_INCORRECT_DATE_OF_BIRTH;
	       }else {
				if (element.name == 'month') {
					COSTCO.rxFamilyAccount.checkDOBMonthValid();
				} else if (element.name == 'day') {
					COSTCO.rxFamilyAccount.checkDOBDayValid();
				} else if (element.name == 'year') {
					COSTCO.rxFamilyAccount.checkDOBYearValid();
				} 
	       }
	       valid = false;
	     }
	     return valid;
	   }, '');
			
	$.validator.addMethod("firstNameValidation", function( value, element ) {
		return COSTCO.rxFamilyAccount.checkFirstNameValid();
	}, "");

	$.validator.addMethod("lastNameValidation", function( value, element ) {
		return COSTCO.rxFamilyAccount.checkLastNameValid();
	}, "");

 	$.validator.addMethod("relationshipValidation", function(value, element, param) {
		return COSTCO.rxFamilyAccount.checkPatientRelationshipValid();
	}, "");

	$.validator.addMethod('genderValidation', function (value, element) {
		return COSTCO.rxFamilyAccount.checkGenderValid();
	}, "");

	$.validator.addMethod('emailAddressRequired', function (value, element) {		
		if (value == ""){
			$('#family_member_email_address_error').addClass('hidden');
			return false;
		}
		return true;
	}, "");

	},
    
			
    	
 	
	/**
     * This is the form handler for the add dependent account form).
     * @return {void}
     */
    addDependentFormHandler: function() {
    	rxFamilyAccount.addValidationMethods();
		let form = rxFamilyAccount.getForm();
		
		if (form != undefined) {
    	
    	form.validate({
		        rules: {
		          firstName: { required: false,  firstNameValidation: true },	
		          lastName: { required: false, lastNameValidation:true},
		          relationship: {required:false, relationshipValidation: true},
		          month: {required: false, dob: true},
		          day: {required: false, dob: true},
		          year: {required: false, dob: true},
		          depGender:{required:false, genderValidation:true},
		          emailAddress:{emailAddressRequired:true, emailAddress:true}
		        },
		        messages: {
					emailAddress: {emailAddressRequired:messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS},
				},
		         errorPlacement:
	    		   function(error, element){
					if ( element.is(":radio") ){
						error.appendTo( element.parents('.gender-radio') );
					}  else { // This is the default behavior of the script for all fields
			            error.insertAfter( element );
			        }
				}		          
    	   });
			return this.getForm().valid();
		}
   },
   
	getForm : function(){
		var forms = $('#dependent-modal');
			return forms;
		}
  }

	if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
	} 
	
	window.COSTCO.rxFamilyAccount = rxFamilyAccount;
		
	return rxFamilyAccount;
    
});


// WEBPACK FOOTER //
// ./js/rx/rxfamilyaccount.js